{
  "Archer": {
    "primary": {
      "Charge+1": {
        "mode": 55,
        "min": 50,
        "max": 60
      },
      "Charge+10": {
        "mode": 30,
        "min": 22,
        "max": 45
      },
      "Charge+2": {
        "mode": 40,
        "min": 35,
        "max": 50
      },
      "Charge+20": {
        "mode": 21,
        "min": 15,
        "max": 31
      },
      "Charge+3": {
        "mode": 40,
        "min": 35,
        "max": 50
      },
      "Charge+4": {
        "mode": 40,
        "min": 35,
        "max": 50
      },
      "Charge+5": {
        "mode": 40,
        "min": 35,
        "max": 50
      },
      "Charge+7": {
        "mode": 40,
        "min": 35,
        "max": 50
      }
    },
    "secondary": {
      "Charge+1": {
        "mode": 51,
        "min": 51,
        "max": 56
      },
      "Charge+10": {
        "mode": 25,
        "min": 25,
        "max": 37
      },
      "Charge+2": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Charge+20": {
        "mode": 18,
        "min": 17,
        "max": 27
      },
      "Charge+3": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Charge+4": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Charge+5": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Charge+7": {
        "mode": 35,
        "min": 35,
        "max": 45
      }
    }
  },
  "Bard": {
    "primary": {
      "Angel Song": {
        "mode": 40,
        "min": 35,
        "max": 50
      },
      "Battle Song": {
        "mode": 40,
        "min": 35,
        "max": 50
      },
      "Cheer Song": {
        "mode": 40,
        "min": 35,
        "max": 50
      },
      "Diamond Blade": {
        "mode": 30,
        "min": 22,
        "max": 46
      },
      "Hydra Pit": {
        "mode": 30,
        "min": 22,
        "max": 45
      },
      "Last Song": {
        "mode": 35,
        "min": 26,
        "max": 49
      },
      "Life Song": {
        "mode": 40,
        "min": 35,
        "max": 50
      },
      "Magic Song": {
        "mode": 40,
        "min": 35,
        "max": 50
      },
      "Nameless Song": {
        "mode": 30,
        "min": 22,
        "max": 45
      },
      "Sky Demon": {
        "mode": 30,
        "min": 21,
        "max": 44
      },
      "Space Storage": {
        "mode": 26,
        "min": 18,
        "max": 40
      }
    },
    "secondary": {
      "Angel Song": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Battle Song": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Cheer Song": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Diamond Blade": {
        "mode": 25,
        "min": 24,
        "max": 38
      },
      "Hydra Pit": {
        "mode": 25,
        "min": 24,
        "max": 37
      },
      "Last Song": {
        "mode": 30,
        "min": 30,
        "max": 44
      },
      "Life Song": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Magic Song": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Nameless Song": {
        "mode": 25,
        "min": 25,
        "max": 37
      },
      "Sky Demon": {
        "mode": 25,
        "min": 24,
        "max": 37
      },
      "Space Storage": {
        "mode": 22,
        "min": 21,
        "max": 34
      }
    }
  },
  "Calculator": {
    "primary": {
      "3": {
        "mode": 49,
        "min": 48,
        "max": 100
      },
      "4": {
        "mode": 100,
        "min": 48,
        "max": 100
      },
      "5": {
        "mode": 51,
        "min": 48,
        "max": 100
      },
      "CT": {
        "mode": 100,
        "min": 48,
        "max": 100
      },
      "Height": {
        "mode": 48,
        "min": 48,
        "max": 100
      },
      "Prime Number": {
        "mode": 48,
        "min": 48,
        "max": 100
      }
    },
    "secondary": {
      "3": {
        "mode": 100,
        "min": 39,
        "max": 100
      },
      "4": {
        "mode": 100,
        "min": 39,
        "max": 100
      },
      "5": {
        "mode": 41,
        "min": 41,
        "max": 100
      },
      "CT": {
        "mode": 40,
        "min": 39,
        "max": 100
      },
      "Height": {
        "mode": 100,
        "min": 39,
        "max": 100
      },
      "Prime Number": {
        "mode": 40,
        "min": 39,
        "max": 43
      }
    }
  },
  "Chemist": {
    "primary": {
      "Antidote": {
        "mode": 65,
        "min": 65,
        "max": 68
      },
      "Echo Grass": {
        "mode": 65,
        "min": 64,
        "max": 67
      },
      "Elixir": {
        "mode": 4,
        "min": 4,
        "max": 9
      },
      "Ether": {
        "mode": 43,
        "min": 42,
        "max": 51
      },
      "Eye Drop": {
        "mode": 65,
        "min": 65,
        "max": 68
      },
      "Hi-Ether": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Hi-Potion": {
        "mode": 45,
        "min": 44,
        "max": 52
      },
      "Holy Water": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Maiden's Kiss": {
        "mode": 64,
        "min": 64,
        "max": 67
      },
      "Phoenix Down": {
        "mode": 85,
        "min": 85,
        "max": 86
      },
      "Potion": {
        "mode": 78,
        "min": 77,
        "max": 80
      },
      "Remedy": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Soft": {
        "mode": 64,
        "min": 64,
        "max": 67
      },
      "X-Potion": {
        "mode": 40,
        "min": 40,
        "max": 50
      }
    },
    "secondary": {
      "Antidote": {
        "mode": 60,
        "min": 56,
        "max": 63
      },
      "Echo Grass": {
        "mode": 59,
        "min": 55,
        "max": 62
      },
      "Elixir": {
        "mode": 3,
        "min": 1,
        "max": 9
      },
      "Ether": {
        "mode": 38,
        "min": 33,
        "max": 46
      },
      "Eye Drop": {
        "mode": 60,
        "min": 56,
        "max": 64
      },
      "Hi-Ether": {
        "mode": 35,
        "min": 31,
        "max": 45
      },
      "Hi-Potion": {
        "mode": 35,
        "min": 31,
        "max": 45
      },
      "Holy Water": {
        "mode": 35,
        "min": 31,
        "max": 45
      },
      "Maiden's Kiss": {
        "mode": 58,
        "min": 54,
        "max": 61
      },
      "Phoenix Down": {
        "mode": 80,
        "min": 76,
        "max": 81
      },
      "Potion": {
        "mode": 73,
        "min": 68,
        "max": 76
      },
      "Remedy": {
        "mode": 35,
        "min": 31,
        "max": 45
      },
      "Soft": {
        "mode": 58,
        "min": 53,
        "max": 60
      },
      "X-Potion": {
        "mode": 34,
        "min": 29,
        "max": 45
      }
    }
  },
  "Dancer": {
    "primary": {
      "Disillusion": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Dragon Pit": {
        "mode": 30,
        "min": 29,
        "max": 46
      },
      "Last Dance": {
        "mode": 35,
        "min": 35,
        "max": 49
      },
      "Nameless Dance": {
        "mode": 30,
        "min": 30,
        "max": 45
      },
      "Nether Demon": {
        "mode": 30,
        "min": 29,
        "max": 46
      },
      "Obsidian Blade": {
        "mode": 30,
        "min": 29,
        "max": 46
      },
      "Polka Polka": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Slow Dance": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Void Storage": {
        "mode": 26,
        "min": 25,
        "max": 40
      },
      "Witch Hunt": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Wiznaibus": {
        "mode": 40,
        "min": 40,
        "max": 50
      }
    },
    "secondary": {
      "Disillusion": {
        "mode": 35,
        "min": 35,
        "max": 35
      },
      "Dragon Pit": {
        "mode": 25,
        "min": 24,
        "max": 26
      },
      "Last Dance": {
        "mode": 30,
        "min": 30,
        "max": 30
      },
      "Nameless Dance": {
        "mode": 25,
        "min": 25,
        "max": 25
      },
      "Nether Demon": {
        "mode": 25,
        "min": 24,
        "max": 26
      },
      "Obsidian Blade": {
        "mode": 25,
        "min": 24,
        "max": 26
      },
      "Polka Polka": {
        "mode": 35,
        "min": 35,
        "max": 35
      },
      "Slow Dance": {
        "mode": 35,
        "min": 35,
        "max": 35
      },
      "Void Storage": {
        "mode": 22,
        "min": 21,
        "max": 23
      },
      "Witch Hunt": {
        "mode": 35,
        "min": 35,
        "max": 35
      },
      "Wiznaibus": {
        "mode": 35,
        "min": 35,
        "max": 35
      }
    }
  },
  "Geomancer": {
    "primary": {
      "Blizzard": {
        "mode": 63,
        "min": 62,
        "max": 75
      },
      "Gusty Wind": {
        "mode": 65,
        "min": 62,
        "max": 75
      },
      "Hallowed Ground": {
        "mode": 65,
        "min": 62,
        "max": 74
      },
      "Hell Ivy": {
        "mode": 63,
        "min": 62,
        "max": 75
      },
      "Lava Ball": {
        "mode": 64,
        "min": 62,
        "max": 73
      },
      "Local Quake": {
        "mode": 63,
        "min": 62,
        "max": 75
      },
      "Pitfall": {
        "mode": 63,
        "min": 62,
        "max": 72
      },
      "Quicksand": {
        "mode": 63,
        "min": 62,
        "max": 72
      },
      "Sand Storm": {
        "mode": 65,
        "min": 62,
        "max": 74
      },
      "Static Shock": {
        "mode": 63,
        "min": 62,
        "max": 72
      },
      "Water Ball": {
        "mode": 63,
        "min": 62,
        "max": 74
      },
      "Will-O-Wisp": {
        "mode": 63,
        "min": 62,
        "max": 72
      }
    },
    "secondary": {
      "Blizzard": {
        "mode": 60,
        "min": 55,
        "max": 70
      },
      "Gusty Wind": {
        "mode": 60,
        "min": 55,
        "max": 70
      },
      "Hallowed Ground": {
        "mode": 60,
        "min": 55,
        "max": 70
      },
      "Hell Ivy": {
        "mode": 60,
        "min": 55,
        "max": 70
      },
      "Lava Ball": {
        "mode": 60,
        "min": 55,
        "max": 70
      },
      "Local Quake": {
        "mode": 60,
        "min": 55,
        "max": 70
      },
      "Pitfall": {
        "mode": 60,
        "min": 55,
        "max": 70
      },
      "Quicksand": {
        "mode": 60,
        "min": 55,
        "max": 70
      },
      "Sand Storm": {
        "mode": 60,
        "min": 55,
        "max": 70
      },
      "Static Shock": {
        "mode": 60,
        "min": 55,
        "max": 70
      },
      "Water Ball": {
        "mode": 60,
        "min": 55,
        "max": 70
      },
      "Will-O-Wisp": {
        "mode": 60,
        "min": 55,
        "max": 70
      }
    }
  },
  "Knight": {
    "primary": {
      "Armor Rend": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Dark Sword": {
        "mode": 22,
        "min": 22,
        "max": 34
      },
      "Explosion Sword": {
        "mode": 7,
        "min": 7,
        "max": 13
      },
      "Head Rend": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Justice Sword": {
        "mode": 33,
        "min": 32,
        "max": 49
      },
      "Magic Ruin": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Mind Break": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Night Sword": {
        "mode": 20,
        "min": 20,
        "max": 30
      },
      "Power Break": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Shield Rend": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Speed Break": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Stasis Sword": {
        "mode": 25,
        "min": 25,
        "max": 37
      },
      "Surging Sword": {
        "mode": 15,
        "min": 15,
        "max": 22
      },
      "Weapon Rend": {
        "mode": 40,
        "min": 40,
        "max": 50
      }
    },
    "secondary": {
      "Armor Rend": {
        "mode": 35,
        "min": 30,
        "max": 35
      },
      "Dark Sword": {
        "mode": 19,
        "min": 14,
        "max": 19
      },
      "Explosion Sword": {
        "mode": 6,
        "min": 4,
        "max": 6
      },
      "Head Rend": {
        "mode": 35,
        "min": 30,
        "max": 35
      },
      "Justice Sword": {
        "mode": 28,
        "min": 20,
        "max": 28
      },
      "Magic Ruin": {
        "mode": 35,
        "min": 30,
        "max": 35
      },
      "Mind Break": {
        "mode": 35,
        "min": 30,
        "max": 35
      },
      "Night Sword": {
        "mode": 17,
        "min": 12,
        "max": 17
      },
      "Power Break": {
        "mode": 35,
        "min": 30,
        "max": 35
      },
      "Shield Rend": {
        "mode": 35,
        "min": 30,
        "max": 35
      },
      "Speed Break": {
        "mode": 35,
        "min": 30,
        "max": 35
      },
      "Stasis Sword": {
        "mode": 21,
        "min": 15,
        "max": 21
      },
      "Surging Sword": {
        "mode": 13,
        "min": 9,
        "max": 13
      },
      "Weapon Rend": {
        "mode": 35,
        "min": 30,
        "max": 35
      }
    }
  },
  "Lancer": {
    "primary": {
      "Level Jump2": {
        "mode": 0,
        "min": 0,
        "max": 100
      },
      "Level Jump2.5": {
        "mode": 0,
        "min": 0,
        "max": 36
      },
      "Level Jump3": {
        "mode": 0,
        "min": 0,
        "max": 36
      },
      "Level Jump3.5": {
        "mode": 0,
        "min": 0,
        "max": 36
      },
      "Level Jump4": {
        "mode": 0,
        "min": 0,
        "max": 35
      },
      "Level Jump5": {
        "mode": 0,
        "min": 0,
        "max": 34
      },
      "Level Jump6": {
        "mode": 25,
        "min": 0,
        "max": 29
      },
      "Level Jump7": {
        "mode": 22,
        "min": 22,
        "max": 25
      },
      "Vertical Jump2": {
        "mode": 0,
        "min": 0,
        "max": 100
      },
      "Vertical Jump2.5": {
        "mode": 0,
        "min": 0,
        "max": 31
      },
      "Vertical Jump3": {
        "mode": 0,
        "min": 0,
        "max": 36
      },
      "Vertical Jump3.5": {
        "mode": 0,
        "min": 0,
        "max": 36
      },
      "Vertical Jump4": {
        "mode": 0,
        "min": 0,
        "max": 35
      },
      "Vertical Jump5": {
        "mode": 0,
        "min": 0,
        "max": 34
      },
      "Vertical Jump6": {
        "mode": 25,
        "min": 0,
        "max": 29
      },
      "Vertical Jump7": {
        "mode": 22,
        "min": 22,
        "max": 25
      }
    },
    "secondary": {
      "Level Jump2": {
        "mode": 0,
        "min": 0,
        "max": 100
      },
      "Level Jump2.5": {
        "mode": 0,
        "min": 0,
        "max": 30
      },
      "Level Jump3": {
        "mode": 0,
        "min": 0,
        "max": 30
      },
      "Level Jump3.5": {
        "mode": 0,
        "min": 0,
        "max": 30
      },
      "Level Jump4": {
        "mode": 0,
        "min": 0,
        "max": 30
      },
      "Level Jump5": {
        "mode": 0,
        "min": 0,
        "max": 29
      },
      "Level Jump6": {
        "mode": 24,
        "min": 0,
        "max": 28
      },
      "Level Jump7": {
        "mode": 21,
        "min": 21,
        "max": 24
      },
      "Vertical Jump2": {
        "mode": 0,
        "min": 0,
        "max": 100
      },
      "Vertical Jump2.5": {
        "mode": 0,
        "min": 0,
        "max": 30
      },
      "Vertical Jump3": {
        "mode": 0,
        "min": 0,
        "max": 30
      },
      "Vertical Jump3.5": {
        "mode": 0,
        "min": 0,
        "max": 35
      },
      "Vertical Jump4": {
        "mode": 0,
        "min": 0,
        "max": 34
      },
      "Vertical Jump5": {
        "mode": 0,
        "min": 0,
        "max": 33
      },
      "Vertical Jump6": {
        "mode": 24,
        "min": 0,
        "max": 28
      },
      "Vertical Jump7": {
        "mode": 21,
        "min": 21,
        "max": 24
      }
    }
  },
  "Mediator": {
    "primary": {
      "Death Sentence": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Insult": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Invitation": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Mimic Daravon": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Negotiate": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Persuade": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Praise": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Preach": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Refute": {
        "mode": 70,
        "min": 70,
        "max": 73
      },
      "Rehabilitate": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Solution": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Threaten": {
        "mode": 40,
        "min": 40,
        "max": 50
      }
    },
    "secondary": {
      "Death Sentence": {
        "mode": 35,
        "min": 30,
        "max": 45
      },
      "Insult": {
        "mode": 35,
        "min": 30,
        "max": 45
      },
      "Invitation": {
        "mode": 35,
        "min": 30,
        "max": 45
      },
      "Mimic Daravon": {
        "mode": 35,
        "min": 30,
        "max": 45
      },
      "Negotiate": {
        "mode": 35,
        "min": 30,
        "max": 45
      },
      "Persuade": {
        "mode": 35,
        "min": 30,
        "max": 45
      },
      "Praise": {
        "mode": 35,
        "min": 30,
        "max": 45
      },
      "Preach": {
        "mode": 35,
        "min": 30,
        "max": 45
      },
      "Refute": {
        "mode": 65,
        "min": 60,
        "max": 68
      },
      "Rehabilitate": {
        "mode": 35,
        "min": 30,
        "max": 45
      },
      "Solution": {
        "mode": 35,
        "min": 30,
        "max": 45
      },
      "Threaten": {
        "mode": 35,
        "min": 30,
        "max": 45
      }
    }
  },
  "Mime": {
    "primary": {
      "Mimic": {
        "mode": 100,
        "min": 100,
        "max": 100
      }
    }
  },
  "Monk": {
    "primary": {
      "Chakra": {
        "mode": 45,
        "min": 45,
        "max": 52
      },
      "Earth Slash": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Pummel": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Purification": {
        "mode": 80,
        "min": 80,
        "max": 82
      },
      "Revive": {
        "mode": 71,
        "min": 70,
        "max": 74
      },
      "Seal Evil": {
        "mode": 35,
        "min": 35,
        "max": 49
      },
      "Secret Fist": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Spin Fist": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Wave Fist": {
        "mode": 40,
        "min": 40,
        "max": 50
      }
    },
    "secondary": {
      "Chakra": {
        "mode": 40,
        "min": 35,
        "max": 47
      },
      "Earth Slash": {
        "mode": 35,
        "min": 30,
        "max": 45
      },
      "Pummel": {
        "mode": 35,
        "min": 30,
        "max": 45
      },
      "Purification": {
        "mode": 75,
        "min": 70,
        "max": 77
      },
      "Revive": {
        "mode": 66,
        "min": 61,
        "max": 69
      },
      "Seal Evil": {
        "mode": 30,
        "min": 22,
        "max": 44
      },
      "Secret Fist": {
        "mode": 35,
        "min": 30,
        "max": 45
      },
      "Spin Fist": {
        "mode": 35,
        "min": 30,
        "max": 45
      },
      "Wave Fist": {
        "mode": 35,
        "min": 30,
        "max": 45
      }
    }
  },
  "Ninja": {
    "primary": {
      "Axe": {
        "mode": 6,
        "min": 4,
        "max": 6
      },
      "Bomb": {
        "mode": 45,
        "min": 40,
        "max": 45
      },
      "Dictionary": {
        "mode": 13,
        "min": 9,
        "max": 14
      },
      "Hammer": {
        "mode": 5,
        "min": 3,
        "max": 5
      },
      "Knife": {
        "mode": 25,
        "min": 18,
        "max": 25
      },
      "Ninja Sword": {
        "mode": 10,
        "min": 8,
        "max": 11
      },
      "Shuriken": {
        "mode": 60,
        "min": 55,
        "max": 60
      },
      "Spear": {
        "mode": 8,
        "min": 6,
        "max": 8
      },
      "Staff": {
        "mode": 16,
        "min": 12,
        "max": 17
      },
      "Stick": {
        "mode": 9,
        "min": 6,
        "max": 9
      },
      "Sword": {
        "mode": 7,
        "min": 5,
        "max": 7
      },
      "Wand": {
        "mode": 20,
        "min": 15,
        "max": 20
      }
    },
    "secondary": {
      "Axe": {
        "mode": 5,
        "min": 4,
        "max": 11
      },
      "Bomb": {
        "mode": 40,
        "min": 35,
        "max": 47
      },
      "Dictionary": {
        "mode": 11,
        "min": 8,
        "max": 16
      },
      "Hammer": {
        "mode": 4,
        "min": 3,
        "max": 10
      },
      "Knife": {
        "mode": 21,
        "min": 15,
        "max": 31
      },
      "Ninja Sword": {
        "mode": 9,
        "min": 7,
        "max": 16
      },
      "Shuriken": {
        "mode": 55,
        "min": 50,
        "max": 58
      },
      "Spear": {
        "mode": 7,
        "min": 5,
        "max": 13
      },
      "Staff": {
        "mode": 15,
        "min": 11,
        "max": 22
      },
      "Stick": {
        "mode": 8,
        "min": 6,
        "max": 15
      },
      "Sword": {
        "mode": 6,
        "min": 4,
        "max": 12
      },
      "Wand": {
        "mode": 17,
        "min": 12,
        "max": 25
      }
    }
  },
  "Oracle": {
    "primary": {
      "Blind": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Confuse": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Dark Holy": {
        "mode": 30,
        "min": 30,
        "max": 45
      },
      "Dispel Magic": {
        "mode": 70,
        "min": 70,
        "max": 73
      },
      "Doubt Faith": {
        "mode": 35,
        "min": 35,
        "max": 49
      },
      "Enrage": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Foxbird": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Life Drain": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Paralyze": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Petrify": {
        "mode": 25,
        "min": 24,
        "max": 37
      },
      "Poison": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Pray Faith": {
        "mode": 35,
        "min": 35,
        "max": 49
      },
      "Silence": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Sleep": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Spell Absorb": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Zombie": {
        "mode": 40,
        "min": 40,
        "max": 50
      }
    },
    "secondary": {
      "Blind": {
        "mode": 35,
        "min": 35,
        "max": 46
      },
      "Confuse": {
        "mode": 35,
        "min": 35,
        "max": 46
      },
      "Dark Holy": {
        "mode": 25,
        "min": 25,
        "max": 37
      },
      "Dispel Magic": {
        "mode": 65,
        "min": 65,
        "max": 69
      },
      "Doubt Faith": {
        "mode": 30,
        "min": 30,
        "max": 45
      },
      "Enrage": {
        "mode": 35,
        "min": 35,
        "max": 46
      },
      "Foxbird": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Life Drain": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Paralyze": {
        "mode": 35,
        "min": 35,
        "max": 47
      },
      "Petrify": {
        "mode": 21,
        "min": 21,
        "max": 32
      },
      "Poison": {
        "mode": 35,
        "min": 35,
        "max": 46
      },
      "Pray Faith": {
        "mode": 30,
        "min": 30,
        "max": 45
      },
      "Silence": {
        "mode": 35,
        "min": 35,
        "max": 46
      },
      "Sleep": {
        "mode": 35,
        "min": 35,
        "max": 46
      },
      "Spell Absorb": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Zombie": {
        "mode": 35,
        "min": 35,
        "max": 46
      }
    }
  },
  "Priest": {
    "primary": {
      "Cure": {
        "mode": 50,
        "min": 50,
        "max": 55
      },
      "Cure 2": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Cure 3": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Cure 4": {
        "mode": 35,
        "min": 35,
        "max": 49
      },
      "Esuna": {
        "mode": 85,
        "min": 84,
        "max": 86
      },
      "Holy": {
        "mode": 30,
        "min": 28,
        "max": 45
      },
      "Magic Barrier": {
        "mode": 6,
        "min": 5,
        "max": 11
      },
      "Protect": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Protect 2": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Raise": {
        "mode": 80,
        "min": 80,
        "max": 82
      },
      "Raise 2": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Regen": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Reraise": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Shell": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Shell 2": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Wall": {
        "mode": 40,
        "min": 40,
        "max": 50
      }
    },
    "secondary": {
      "Cure": {
        "mode": 45,
        "min": 45,
        "max": 51
      },
      "Cure 2": {
        "mode": 35,
        "min": 35,
        "max": 47
      },
      "Cure 3": {
        "mode": 35,
        "min": 35,
        "max": 47
      },
      "Cure 4": {
        "mode": 30,
        "min": 30,
        "max": 44
      },
      "Esuna": {
        "mode": 80,
        "min": 80,
        "max": 82
      },
      "Holy": {
        "mode": 25,
        "min": 25,
        "max": 39
      },
      "Magic Barrier": {
        "mode": 5,
        "min": 5,
        "max": 10
      },
      "Protect": {
        "mode": 35,
        "min": 35,
        "max": 46
      },
      "Protect 2": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Raise": {
        "mode": 75,
        "min": 75,
        "max": 79
      },
      "Raise 2": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Regen": {
        "mode": 35,
        "min": 35,
        "max": 46
      },
      "Reraise": {
        "mode": 35,
        "min": 35,
        "max": 46
      },
      "Shell": {
        "mode": 35,
        "min": 35,
        "max": 46
      },
      "Shell 2": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Wall": {
        "mode": 35,
        "min": 35,
        "max": 46
      }
    }
  },
  "Samurai": {
    "primary": {
      "Asura": {
        "mode": 53,
        "min": 52,
        "max": 58
      },
      "Bizen Boat": {
        "mode": 50,
        "min": 50,
        "max": 55
      },
      "Chirijiraden": {
        "mode": 4,
        "min": 3,
        "max": 8
      },
      "Heaven's Cloud": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Kikuichimonji": {
        "mode": 32,
        "min": 31,
        "max": 48
      },
      "Kiyomori": {
        "mode": 35,
        "min": 35,
        "max": 49
      },
      "Koutetsu": {
        "mode": 48,
        "min": 47,
        "max": 55
      },
      "Masamune": {
        "mode": 5,
        "min": 4,
        "max": 10
      },
      "Muramasa": {
        "mode": 27,
        "min": 27,
        "max": 42
      },
      "Murasame": {
        "mode": 41,
        "min": 40,
        "max": 51
      }
    },
    "secondary": {
      "Asura": {
        "mode": 50,
        "min": 45,
        "max": 55
      },
      "Bizen Boat": {
        "mode": 45,
        "min": 40,
        "max": 50
      },
      "Chirijiraden": {
        "mode": 3,
        "min": 2,
        "max": 7
      },
      "Heaven's Cloud": {
        "mode": 32,
        "min": 28,
        "max": 43
      },
      "Kikuichimonji": {
        "mode": 23,
        "min": 16,
        "max": 35
      },
      "Kiyomori": {
        "mode": 32,
        "min": 24,
        "max": 43
      },
      "Koutetsu": {
        "mode": 42,
        "min": 38,
        "max": 48
      },
      "Masamune": {
        "mode": 4,
        "min": 2,
        "max": 9
      },
      "Muramasa": {
        "mode": 18,
        "min": 13,
        "max": 27
      },
      "Murasame": {
        "mode": 34,
        "min": 29,
        "max": 44
      }
    }
  },
  "Squire": {
    "primary": {
      "Accumulate": {
        "mode": 50,
        "min": 50,
        "max": 56
      },
      "Cheer Up": {
        "mode": 35,
        "min": 35,
        "max": 49
      },
      "Dash": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Fury": {
        "mode": 35,
        "min": 35,
        "max": 49
      },
      "Heal": {
        "mode": 73,
        "min": 72,
        "max": 75
      },
      "Scream": {
        "mode": 25,
        "min": 25,
        "max": 37
      },
      "Throw Stone": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Tickle": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Ultima": {
        "mode": 6,
        "min": 5,
        "max": 12
      },
      "Wish": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Yell": {
        "mode": 40,
        "min": 40,
        "max": 50
      }
    },
    "secondary": {
      "Accumulate": {
        "mode": 45,
        "min": 45,
        "max": 51
      },
      "Cheer Up": {
        "mode": 30,
        "min": 30,
        "max": 44
      },
      "Dash": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Fury": {
        "mode": 30,
        "min": 30,
        "max": 44
      },
      "Heal": {
        "mode": 67,
        "min": 67,
        "max": 70
      },
      "Scream": {
        "mode": 21,
        "min": 21,
        "max": 31
      },
      "Throw Stone": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Tickle": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Ultima": {
        "mode": 5,
        "min": 5,
        "max": 10
      },
      "Wish": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Yell": {
        "mode": 35,
        "min": 35,
        "max": 45
      }
    }
  },
  "Summoner": {
    "primary": {
      "Bahamut": {
        "mode": 18,
        "min": 17,
        "max": 28
      },
      "Carbunkle": {
        "mode": 60,
        "min": 60,
        "max": 64
      },
      "Cyclops": {
        "mode": 22,
        "min": 21,
        "max": 34
      },
      "Fairy": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Golem": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Ifrit": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Leviathan": {
        "mode": 40,
        "min": 39,
        "max": 50
      },
      "Lich": {
        "mode": 30,
        "min": 30,
        "max": 45
      },
      "Moogle": {
        "mode": 75,
        "min": 75,
        "max": 77
      },
      "Odin": {
        "mode": 25,
        "min": 24,
        "max": 37
      },
      "Ramuh": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Salamander": {
        "mode": 35,
        "min": 34,
        "max": 49
      },
      "Shiva": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Sylph": {
        "mode": 40,
        "min": 39,
        "max": 50
      },
      "Titan": {
        "mode": 40,
        "min": 39,
        "max": 50
      },
      "Zodiac": {
        "mode": 3,
        "min": 2,
        "max": 8
      }
    },
    "secondary": {
      "Bahamut": {
        "mode": 17,
        "min": 16,
        "max": 24
      },
      "Carbunkle": {
        "mode": 56,
        "min": 56,
        "max": 59
      },
      "Cyclops": {
        "mode": 19,
        "min": 18,
        "max": 27
      },
      "Fairy": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Golem": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Ifrit": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Leviathan": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Lich": {
        "mode": 25,
        "min": 25,
        "max": 37
      },
      "Moogle": {
        "mode": 70,
        "min": 70,
        "max": 72
      },
      "Odin": {
        "mode": 21,
        "min": 21,
        "max": 31
      },
      "Ramuh": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Salamander": {
        "mode": 30,
        "min": 30,
        "max": 44
      },
      "Shiva": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Sylph": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Titan": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Zodiac": {
        "mode": 3,
        "min": 3,
        "max": 7
      }
    }
  },
  "Thief": {
    "primary": {
      "Arm Aim": {
        "mode": 35,
        "min": 35,
        "max": 49
      },
      "Gil Taking": {
        "mode": 38,
        "min": 38,
        "max": 50
      },
      "Leg Aim": {
        "mode": 35,
        "min": 35,
        "max": 49
      },
      "Steal Accessory": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Steal Armor": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Steal Heart": {
        "mode": 41,
        "min": 41,
        "max": 51
      },
      "Steal Helmet": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Steal Shield": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Steal Status": {
        "mode": 33,
        "min": 32,
        "max": 49
      },
      "Steal Weapon": {
        "mode": 40,
        "min": 40,
        "max": 50
      }
    },
    "secondary": {
      "Arm Aim": {
        "mode": 30,
        "min": 22,
        "max": 44
      },
      "Gil Taking": {
        "mode": 33,
        "min": 25,
        "max": 45
      },
      "Leg Aim": {
        "mode": 30,
        "min": 22,
        "max": 44
      },
      "Steal Accessory": {
        "mode": 35,
        "min": 30,
        "max": 45
      },
      "Steal Armor": {
        "mode": 35,
        "min": 30,
        "max": 45
      },
      "Steal Heart": {
        "mode": 36,
        "min": 31,
        "max": 46
      },
      "Steal Helmet": {
        "mode": 35,
        "min": 30,
        "max": 45
      },
      "Steal Shield": {
        "mode": 35,
        "min": 30,
        "max": 45
      },
      "Steal Status": {
        "mode": 28,
        "min": 20,
        "max": 42
      },
      "Steal Weapon": {
        "mode": 35,
        "min": 30,
        "max": 45
      }
    }
  },
  "Time Mage": {
    "primary": {
      "Demi": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Demi 2": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Float": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Galaxy Stop": {
        "mode": 5,
        "min": 5,
        "max": 10
      },
      "Haste": {
        "mode": 58,
        "min": 58,
        "max": 61
      },
      "Haste 2": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Immobilize": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Meteor": {
        "mode": 25,
        "min": 25,
        "max": 37
      },
      "Mute": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Old": {
        "mode": 35,
        "min": 35,
        "max": 49
      },
      "Quick": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Reflect": {
        "mode": 43,
        "min": 42,
        "max": 51
      },
      "Slow": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Slow 2": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Stabilize Time": {
        "mode": 68,
        "min": 67,
        "max": 71
      },
      "Stop": {
        "mode": 40,
        "min": 40,
        "max": 50
      }
    },
    "secondary": {
      "Demi": {
        "mode": 35,
        "min": 35,
        "max": 47
      },
      "Demi 2": {
        "mode": 35,
        "min": 35,
        "max": 46
      },
      "Float": {
        "mode": 35,
        "min": 35,
        "max": 47
      },
      "Galaxy Stop": {
        "mode": 5,
        "min": 4,
        "max": 10
      },
      "Haste": {
        "mode": 54,
        "min": 53,
        "max": 58
      },
      "Haste 2": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Immobilize": {
        "mode": 35,
        "min": 35,
        "max": 47
      },
      "Meteor": {
        "mode": 21,
        "min": 21,
        "max": 31
      },
      "Mute": {
        "mode": 35,
        "min": 35,
        "max": 46
      },
      "Old": {
        "mode": 30,
        "min": 30,
        "max": 45
      },
      "Quick": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Reflect": {
        "mode": 38,
        "min": 37,
        "max": 48
      },
      "Slow": {
        "mode": 35,
        "min": 35,
        "max": 46
      },
      "Slow 2": {
        "mode": 35,
        "min": 35,
        "max": 45
      },
      "Stabilize Time": {
        "mode": 62,
        "min": 62,
        "max": 67
      },
      "Stop": {
        "mode": 35,
        "min": 35,
        "max": 47
      }
    }
  },
  "Wizard": {
    "primary": {
      "Bolt": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Bolt 2": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Bolt 3": {
        "mode": 40,
        "min": 39,
        "max": 50
      },
      "Bolt 4": {
        "mode": 35,
        "min": 34,
        "max": 49
      },
      "Death": {
        "mode": 25,
        "min": 23,
        "max": 37
      },
      "Empower": {
        "mode": 30,
        "min": 29,
        "max": 45
      },
      "Fire": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Fire 2": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Fire 3": {
        "mode": 40,
        "min": 39,
        "max": 50
      },
      "Fire 4": {
        "mode": 35,
        "min": 34,
        "max": 49
      },
      "Flare": {
        "mode": 28,
        "min": 25,
        "max": 42
      },
      "Frog": {
        "mode": 24,
        "min": 22,
        "max": 36
      },
      "Ice": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Ice 2": {
        "mode": 40,
        "min": 40,
        "max": 50
      },
      "Ice 3": {
        "mode": 40,
        "min": 39,
        "max": 50
      },
      "Ice 4": {
        "mode": 35,
        "min": 34,
        "max": 49
      }
    },
    "secondary": {
      "Bolt": {
        "mode": 35,
        "min": 35,
        "max": 46
      },
      "Bolt 2": {
        "mode": 35,
        "min": 35,
        "max": 46
      },
      "Bolt 3": {
        "mode": 35,
        "min": 35,
        "max": 47
      },
      "Bolt 4": {
        "mode": 30,
        "min": 30,
        "max": 44
      },
      "Death": {
        "mode": 21,
        "min": 21,
        "max": 32
      },
      "Empower": {
        "mode": 25,
        "min": 25,
        "max": 37
      },
      "Fire": {
        "mode": 35,
        "min": 35,
        "max": 46
      },
      "Fire 2": {
        "mode": 35,
        "min": 35,
        "max": 46
      },
      "Fire 3": {
        "mode": 35,
        "min": 35,
        "max": 46
      },
      "Fire 4": {
        "mode": 30,
        "min": 30,
        "max": 44
      },
      "Flare": {
        "mode": 23,
        "min": 23,
        "max": 35
      },
      "Frog": {
        "mode": 20,
        "min": 20,
        "max": 31
      },
      "Ice": {
        "mode": 35,
        "min": 35,
        "max": 46
      },
      "Ice 2": {
        "mode": 35,
        "min": 35,
        "max": 47
      },
      "Ice 3": {
        "mode": 35,
        "min": 35,
        "max": 47
      },
      "Ice 4": {
        "mode": 30,
        "min": 30,
        "max": 44
      }
    }
  }
}
